





import Vue from "vue"
const default_layout = "default"

export default Vue.extend({
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout"
    }
  },
  metaInfo() {
    return {
      title: "Designer",
      meta: [
        {
          name: "title",
          content: "Designer"
        },
        {
          name: "description",
          content: "Designer"
        }
      ]
    }
  }
})
